/* Yorkshire Interiors — Showroom behaviour (Room One)
   Cinematic reveals, wayfinding rail, conversion checkpoints.
   Progressive enhancement only: the page is complete without JS. */
(function () {
  if (window.YIShowroom) return;
  window.YIShowroom = true;
  document.documentElement.classList.add('yi-js');

  var track = function (event, data) {
    var payload = Object.assign({ event: event }, data || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('yi:analytics', { detail: payload }));
  };

  /* Cinematic reveals */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('yi-inview'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    document.querySelectorAll('.yi-reveal').forEach(function (el) { io.observe(el); });

    /* Wayfinding rail + room-entry checkpoints */
    var roomEls = document.querySelectorAll('[data-yi-room]');
    var links = document.querySelectorAll('.yi-rail a[data-yi-target]');
    var seen = {};
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var room = e.target.getAttribute('data-yi-room');
        links.forEach(function (l) {
          l.classList.toggle('yi-here', l.getAttribute('data-yi-target') === room);
        });
        if (!seen[room]) { seen[room] = true; track('yi_room_enter', { room: room }); }
      });
    }, { threshold: 0, rootMargin: '-30% 0px -55% 0px' });
    roomEls.forEach(function (el) { spy.observe(el); });
  } else {
    document.querySelectorAll('.yi-reveal').forEach(function (el) { el.classList.add('yi-inview'); });
  }

  /* Click checkpoints: any element carrying data-yi-event */
  document.addEventListener('click', function (ev) {
    /* R2 (2026-10-15): count shoppers' taps only. The configurator selects its default
       fabric and storage with element.click(), which was logging selections nobody made. */
    if (!ev.isTrusted) return;
    var el = ev.target.closest('[data-yi-event]');
    if (!el) return;
    track(el.getAttribute('data-yi-event'), {
      label: el.getAttribute('data-yi-label') || null,
      room: (el.closest('[data-yi-room]') || {}).getAttribute
        ? (el.closest('[data-yi-room]')).getAttribute('data-yi-room')
        : null
    });
  }, { passive: true });
})();

/* Loading grace: lazy images fade in on arrival; cached ones show instantly. */
(function () {
  function grace(img) {
    if (img.complete && img.naturalWidth > 0) { img.setAttribute('data-yi-instant', ''); return; }
    img.addEventListener('load', function () { img.classList.add('yi-loaded'); }, { once: true });
    img.addEventListener('error', function () { img.classList.add('yi-loaded'); }, { once: true });
  }
  document.querySelectorAll('img[loading="lazy"]').forEach(grace);
})();

/* yi-art-image: when a mobile composition has its own alt text, keep the announced alt in step with the composition being shown. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  function apply() {
    document.querySelectorAll('img[data-alt-mobile]').forEach(function (img) {
      img.alt = mq.matches ? img.getAttribute('data-alt-mobile') : (img.getAttribute('data-alt-desktop') || img.alt);
    });
  }
  if (mq.addEventListener) mq.addEventListener('change', apply);
  else if (mq.addListener) mq.addListener(apply);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
})();
